import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }

import { GeorgiaDfcsBenefits } from "@minicity/core";
import { onMounted, ref } from "vue";

enum assistanceTypes {
    "Sign language interpreter" = "signLanguageInterpreter",
    "TTY" = "TTY",
    "Large print" = "largePrint",
    "Electronic communication (email)" = "email",
    "Braille" = "braille",
    "Video relay" = "videoRelay",
    "Cued speech interpreter" = "cuedSpeechInterpreter",
    "Oral interpreter" = "oralInterpreter",
    "Tactile interpreter" = "tactileInterpreter",
    "Telephone call reminder of program deadlines" = "telephoneCallReminder",
    "Telephonic signature" = "telephonicSignature",
    "Face-to-face interview" = "faceToFaceInterview",
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RequiredAssistanceEditor',
  props: {
    modelValue: null,
    requiredLabel: null,
    whichTypesLabel: null,
    frequencyLabel: null
  },
  emits: ['update:modelValue', 'enter'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue?: Partial<GeorgiaDfcsBenefits.RequiredAssistance>|null,

  requiredLabel: string,
  whichTypesLabel: string,
  frequencyLabel: string,
}



const isRequired = ref<boolean|null>(null);
const selectedTypes = ref<string[]>([]);
const assistance = ref<GeorgiaDfcsBenefits.RequiredAssistance>({
  signLanguageInterpreter: false,
  TTY: false,
  largePrint: false,
  email: false,
  braille: false,
  videoRelay: false,
  cuedSpeechInterpreter: false,
  oralInterpreter: false,
  tactileInterpreter: false,
  telephoneCallReminder: false,
  telephonicSignature: false,
  faceToFaceInterview: false,
  otherInfo: "",
  frequency: GeorgiaDfcsBenefits.AssistanceFrequency["One time"],
  whenAndHowLongInfo: "",
});

// Event for two-way binding


const onInput = () => {
  for (const [name, key] of Object.entries(assistanceTypes)) {
    assistance.value[key] = selectedTypes.value.includes(key);
  }
  
  const emitValue = isRequired.value ? {...assistance.value} : undefined;
  emit('update:modelValue', emitValue);
};

onMounted(() => {
  if (props.modelValue) {
    isRequired.value = true;
    assistance.value = {...props.modelValue} as GeorgiaDfcsBenefits.RequiredAssistance;

    for (const [name, key] of Object.entries(assistanceTypes)) {
      if (props.modelValue[key]) {
        selectedTypes.value.push(key);
      }
    }
  }
})

return (_ctx: any,_cache: any) => {
  const _component_FormCheckboxField = _resolveComponent("FormCheckboxField")!
  const _component_FormCheckboxGroupField = _resolveComponent("FormCheckboxGroupField")!
  const _component_FormTextField = _resolveComponent("FormTextField")!
  const _component_HalfColumn = _resolveComponent("HalfColumn")!
  const _component_FormRadioGroupField = _resolveComponent("FormRadioGroupField")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FormCheckboxField, {
      boxLabel: __props.requiredLabel,
      modelValue: isRequired.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isRequired).value = $event)),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (onInput()))
    }, null, 8, ["boxLabel", "modelValue"]),
    (isRequired.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_FormCheckboxGroupField, {
            label: __props.whichTypesLabel,
            options: assistanceTypes,
            modelValue: selectedTypes.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedTypes).value = $event)),
            onChange: _cache[3] || (_cache[3] = ($event: any) => (onInput())),
            stacked: ""
          }, null, 8, ["label", "modelValue"]),
          _createVNode(_component_HalfColumn, null, {
            default: _withCtx(() => [
              _createVNode(_component_FormTextField, {
                label: "Any other assistance?",
                modelValue: assistance.value.otherInfo,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((assistance.value.otherInfo) = $event)),
                trimmed: "",
                onChange: _cache[5] || (_cache[5] = ($event: any) => (onInput()))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_FormRadioGroupField, {
            label: __props.frequencyLabel,
            options: _unref(GeorgiaDfcsBenefits).AssistanceFrequency,
            modelValue: assistance.value.frequency,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((assistance.value.frequency) = $event)),
            onChange: _cache[7] || (_cache[7] = ($event: any) => (onInput()))
          }, null, 8, ["label", "options", "modelValue"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})